import { render, staticRenderFns } from "./inpatientDaysPer1000.vue?vue&type=template&id=07cdc6c8"
import script from "./inpatientDaysPer1000.vue?vue&type=script&lang=js"
export * from "./inpatientDaysPer1000.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports